import { render } from "./perceived.vue?vue&type=template&id=42d05e49&scoped=true"
import script from "./perceived.vue?vue&type=script&lang=js"
export * from "./perceived.vue?vue&type=script&lang=js"

import "./perceived.vue?vue&type=style&index=0&id=42d05e49&scoped=true&lang=less"

import exportComponent from "G:\\B030transformer\\demo (2)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d05e49"]])

export default __exports__